import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { createProvider, Step } from '../../../../../../shared/IFE/step/step/step';
import { ChargingStationPlacement } from '../../../../../../shared/modules/evc-api/models/constants';
import { AnalyticsService } from '../../../../../../shared/modules/analytics/services/analytics.service';

@Component({
  selector: 'evc-quote-charging-station-placement',
  providers: [createProvider(ChargingStationPlacementComponent)],
  templateUrl: './charging-station-placement.component.html',
  styleUrls: ['./charging-station-placement.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChargingStationPlacementComponent extends Step implements OnInit {
  readonly chargingStationPlacement = ChargingStationPlacement;

  readonly formName = 'evcQuote';
  readonly stepName: string = 'charging-station-placement';

  public init = false;

  constructor(fb: UntypedFormBuilder, analyticsService: AnalyticsService) {
    super(fb, analyticsService);
  }

  writeValue(value): void {
    if (!value) {
      super.writeValue(value);
      return;
    }

    // We can expect a .init when we visit it for the first time.
    value = value.split('.');
    if (value[1]) {
      this.init = true;
    }
    super.writeValue({ value: value[0] });
  }

  public navigate() {
    this.onModelChange(this.control.get('value').value);
    this.onTouch();
    super.navigate();
  }

  protected valueChanges(values) {
    this.init = false;
    this.control.get('value').patchValue(values.value, { emitEvent: false });
    super.valueChanges(values.value);
  }

  protected buildForm() {
    this.control = this.fb.group({
      value: ['', [Validators.required]],
    });
    this.subscribeToValueChanges(true);
  }
}
